import React from 'react';
import { connect } from 'react-redux';
import Form from '../../../components/form/form';
import Message from '../../../components/message/index';
import Breadcrumb from '../../../components/breadcrumb/index';
import moment from 'moment';
import { errorCodeReport, virtualNumberList, exportOmsgReport } from '../../../actions/actions';
import { scrollToTop } from '../../../actions/utils';
import Select from '../../../components/form/select';

class ErrorCodeReport extends React.Component {
    constructor(props)
    {
        super(props)
        this.reportRef = React.createRef();

        this.state = {
            itemDetailsToShow: [],
            list: [],
            pageNumber: 0,
            virtualNumberList: [],
            downloadOptions: {
                value: 'PDF',
                name: 'downloadOptions',
                type: 'select',
                label: '',
                placeholder: 'Dosya Tipi',
                options: [{name: 'PDF', value: 'pdf'},{name: 'Excel', value: 'xlsx'}],
                error: 'Lütfen dosya tipi seçiniz.',
                valid: true,
                touched: false,
                validationRules: {
                    isRequired: true
                }
            },
            formModel: {
                virtualNumber: {
                    value: '',
                    name: 'virtualNumber',
                    type: 'select',
                    label: 'Sanal Numara',
                    placeholder: 'Sanal Numara',
                    error: 'Lütfen Sanal Numara girin.',
                    options: [],
                    valid: false,
                    touched: false,
                    validationRules: {
                        isRequired: true
                    }
                },
            }
        };

        this.getVirtualNumberList();
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    handleSubmit(data)
    {
        this.getReport(data);
    }

    getReport(data){
        var foundedObj = this.state.virtualNumberList.find(vm => vm.product.virtualNumber === data.virtualNumber).product;
        foundedObj.tariff = foundedObj.tariffName;

        this.props.dispatch(errorCodeReport(foundedObj, (response) => {
            this.setState({
                itemDetailsToShow: [],
                list: response.reportItems,
                pageNumber: response.pageNumber,
            });
        }, (data) => {
            scrollToTop();
        }));
    }

    getVirtualNumberList(){
        this.props.dispatch(virtualNumberList((response) => {
        }, (data) => {
            this.setState({
                virtualNumberList: data,
                formModel: {
                    ...this.state.formModel,
                    virtualNumber: {
                        ...this.state.formModel.virtualNumber,
                        options: data.map(x => ({value:x.product.virtualNumber, name:x.product.virtualNumber}))
                    }
                }
            })
        }));
    }

    async changePage(nextPageNumber){
        if(nextPageNumber === -1 && this.state.pageNumber === 0) {

        } else {
            this.getReport({virtualNumber:this.state.formModel.virtualNumber.value, pageNumber: nextPageNumber});
        }
    }

    downloadReport() {
        if(this.state.downloadOptions.value != '') {
            var foundedObj = this.state.virtualNumberList.find(vm => vm.product.virtualNumber === this.state.formModel.virtualNumber.value).product;
            let requestData = {
                type: 'error_code',
                tariff: foundedObj.tariffName,
                docType: this.state.downloadOptions.value,
                reportRequest: {
                    virtualNumber:this.state.formModel.virtualNumber.value,
                    pageNumber: this.state.pageNumber,
                    ...foundedObj
                }
            }
            this.props.dispatch(exportOmsgReport(requestData, () => {
            }, () => {
    
            }));
        }
    }

    handleSelectDownloadOption(data){
        if(data.target.value != '') {
            this.setState({downloadOptions: {...this.state.downloadOptions, value: data.target.value}})
        } else{
            this.setState({downloadOptions: {...this.state.downloadOptions, value: data.target.value}})
        }
    }

    render() {
        const breadcrumbItems = [{
            name: "Hata Kodu Raporu"
        }];

        return (
        [
            <Breadcrumb items={breadcrumbItems} />,
            <section className="panel">
                <Message />
                <div className="container">
                    <div className="reports">
                        <div className="title-default">
                            <span>Hata Kodu Raporu</span>
                        </div>
                        <div className="report-form">
                            <Form model={this.state.formModel} handleSubmit={this.handleSubmit} smallTitle={""} buttonText={"Rapor Oluştur"} multipleColumn={true} buttonId={"report-list-filter"} />
                        </div>  
                        {this.state.list.length > 0 && 
                        <div>
                               <div style={{display: 'table', textAlign:'center', width: '100%', margin:'10px 0 10px 0'}}>
                            <div style={{display:'table-cell', width:'50vh', verticalAlign:'middle', paddingRight:'5px'}}>
                            <Select data={this.state.downloadOptions} handleChange={this.handleSelectDownloadOption.bind(this)} />

                            </div>
                            <div style={{display:'table-cell', width:'50vh', paddingLeft:'5px'}}>
                            <a id="report-send-download" className="btn primary" href="javascript:void(0)" title="Tümünü indir" onClick={this.downloadReport.bind(this)}>
                                                    <span>Tümünü indir</span>
                                                </a>
                            </div>
                        </div>
                                <div className="report-items">
                                    <div ref={this.reportRef} className="head">
                                        <div className="item">
                                            <div>Sanal Numara</div>
                                            <div>Tarife Adı</div>
                                            <div>Tarih</div>
                                            <div>Başarısız Olan/İletilemeyen Abone Sayısı</div>
                                            <div>Hata Kodu</div>
                                        </div>
                                    </div>
                                    <div className="body">
                                        {this.state.list.map((item, i) =>
                                            <div className="item">
                                                <div>
                                                    <span className="label">Sanal Numara</span>
                                                    <span>{item.companyMsisdn}</span>
                                                </div>
                                                <div>
                                                    <span className="label">Tarife Adı</span>
                                                    <span>{item.tariff}</span>
                                                </div>
                                                <div>
                                                    <span className="label">Tarih</span>
                                                    <span>{moment(item.date).format('DD.MM.YYYY')}</span>
                                                </div>
                                                <div>
                                                    <span className="label">Başarısız Olan/İletilemeyen Abone Sayısı</span>
                                                    <span>{item.failedTotal}</span>
                                                </div>
                                                <div>
                                                    <span className="label">Hata Kodu</span>
                                                    <span>
                                                    {(item.errorDetail === 'BARRING' ? 'Sms Alımına Kısıtlı' :
                                                        (item.errorDetail === 'UNKNOWN_NO' ? 'Bilinmeyen Numara' :
                                                        (item.errorDetail === 'NOTIYS' ? 'İYS Hatası' :
                                                        (item.errorDetail === 'SISERROR' ? 'Sistem Hatası' :
                                                        (item.errorDetail === 'REJECT' ? 'Reddedildi' : (item.errorDetail === 'OTHER' ? 'Diğer' : ''))))))} </span>
                                             </div>
                                             </div>
                                            )}
                                    </div>
                                </div>
                          
                        </div>
                          }
                          {this.state.list.length > 0 &&
                            <div className="paging">
                                {this.state.pageNumber !== 0 && <a href="javascript:void(0)" className={"first-item"} onClick={() => this.changePage(-1)}>&lt;&lt;</a>}
                                <a href="javascript:void(0)" className={"last-item"}  onClick={() => this.changePage(+1)}>&gt;&gt;</a>
                            </div>
                          }
                      </div>
                </div>
            </section>
        ]
      );
    }
}

function mapStateToProps(state) {
    return {
        app: state.app 
    }
}


export default connect(mapStateToProps)(ErrorCodeReport)